import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const DEFAULT_TZ = "Asia/Dubai";

export function formatDate(date: string | Date, tz: string = DEFAULT_TZ) {
  return dayjs(date).tz(tz).format("DD MMM YYYY");
}

export function formatTime(
  date: string | Date,
  tz: string = DEFAULT_TZ,
  options?: { ampm?: boolean },
) {
  return dayjs(date)
    .tz(tz)
    .format(options?.ampm === false ? "h:mm" : "h:mm A");
}

export default function secondsToHms(d: number) {
  d = Number(d);
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);

  const hour = h.toString().length === 1 ? `0${h}` : `${h}`;
  const minute = m.toString().length === 1 ? `0${m}` : `${m}`;
  const second = s.toString().length === 1 ? `0${s}` : `${s}`;

  return { hour, minute, second };
}

export const getLastToken = (u: any) => {
  const parts = u.split("/").filter(Boolean);
  return parts.length ? parts[parts.length - 1] : null;
};

export const checkTokenExpired = (tokenExpiry: string | undefined) => {
  if (tokenExpiry) {
    // Get the current UTC time
    const currentTime = new Date();
    // added a buffer 3 min   to avoid edge case failure
    const currentTimePlusThreeMinutes = new Date(
      currentTime.getTime() + 3 * 60 * 1000,
    );
    const expiryDate = new Date(tokenExpiry);
    if (isNaN(expiryDate.getTime())) {
      return true;
    } else {
      // Check if the access token expiry time is in the future
      const hasExpired = expiryDate < currentTimePlusThreeMinutes;
      return hasExpired;
    }
  } else {
    return true;
  }
};
